export const SLOT = {
  CRANIUM: 'cranium',
  BACK: 'back',
  TAIL: 'tail',
  WORLD: 'world',
} as const;
